var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title,
      "class-name": "vertical-center-modal"
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "category",
      "label": "试用类别"
    }
  }, [_c('Select', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('category');
      }
    },
    model: {
      value: _vm.data.category,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "category", $$v);
      },
      expression: "data.category"
    }
  }, _vm._l(_vm.categories, function (c) {
    return _c('Option', {
      key: c,
      attrs: {
        "value": c
      }
    }, [_vm._v(_vm._s(c))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "customer",
      "label": "试用单位"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('customer');
      }
    },
    model: {
      value: _vm.data.customer,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "customer", $$v);
      },
      expression: "data.customer"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "expire_date",
      "label": "过期时间"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "options": _vm.options,
      "clearable": false,
      "start-date": new Date()
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('expire_date');
      }
    },
    model: {
      value: _vm.data.expire_date,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "expire_date", $$v);
      },
      expression: "data.expire_date"
    }
  }), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("(不超过" + _vm._s(_vm.user.max_trial_days) + "天)")])], 1), _c('FormItem', {
    attrs: {
      "prop": "point_num",
      "label": "试用点数"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "max": _vm.user.max_point_num,
      "precision": 0
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('point_num');
      }
    },
    model: {
      value: _vm.data.point_num,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "point_num", $$v);
      },
      expression: "data.point_num"
    }
  }), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("(1-" + _vm._s(_vm.user.max_point_num) + ")")])], 1), _c('FormItem', {
    attrs: {
      "prop": "product",
      "label": "产品明细"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('product');
      }
    },
    model: {
      value: _vm.data.product,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "product", $$v);
      },
      expression: "data.product"
    }
  }, _vm._l(_vm.products, function (p, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.product_name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "remark",
      "label": "申请说明"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "textarea"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('remark');
      }
    },
    model: {
      value: _vm.data.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "remark", $$v);
      },
      expression: "data.remark"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };